import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef } from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';

import {CalendarService} from '../../../service/calendar/service-calendar';
import {CalendarFileService} from '../../../service/calendar/service-calendarfile';
import {CalendarDepartService} from '../../../service/calendar/service-calendardepart';
import {Sessioncommand} from '../../../global/sessioncommand';
import {CalendarDepartFileService} from '../../../service/calendar/service-calendardepartfile';
import {CalendarDepartFile} from '../../../models/calendar/calendardepartfile';
import {DatePipe} from '@angular/common';
import {CalendarFile} from '../../../models/calendar/calendarfile';
@Component({
  templateUrl: './edit.component.html'

})
export class EditLichCaNhanComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public tuNgay: Date = new Date();
  public denNgay: Date = new Date();
  public onClose: Subject<boolean>;
  public isSuDung: boolean = true;
  constructor( public calendarService: CalendarService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public calendarFileService: CalendarFileService,
               public _bsModalRef: BsModalRef,
               public datePipe: DatePipe

  ) {
  }
  ngAfterViewInit() {

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      tuNgay: new FormControl(),
      tuGio: new FormControl(''),
      denNgay: new FormControl(0),
      denGio: new FormControl(0),
      noiDung: new FormControl(),
      diaDiem: new FormControl(),
      chuTri: new FormControl(),
      ghiChu: new FormControl(),
      bgColor: new FormControl(),
      beLongTo: new FormControl(),
      trangThai: new FormControl(),
      suDung: new FormControl()
    });
    this.frmGroup = this.formBuilder.group({
      id: ['' , Validators.nullValidator ],
      tuNgay: ['' , Validators.compose([validateEmpty]) ],
      denNgay: ['' , Validators.compose([validateEmpty]) ],
      ghiChu: ['', Validators.nullValidator],
      noiDung: ['' , Validators.compose([validateEmpty]) ],
      beLongTo: ['', Validators.nullValidator],
      chuTri: ['', Validators.nullValidator],
      diaDiem: ['', Validators.nullValidator],
      tuGio: ['', Validators.nullValidator],
      denGio: ['', Validators.nullValidator],
      bgColor: ['', Validators.nullValidator],
      trangThai: ['', Validators.nullValidator],
      suDung: ['', Validators.nullValidator]
    });
    this.uploadUrl= this.calendarFileService.urlUpload;
    this.deleteUrl= this.calendarFileService.urlDelete;

  }
  get f() { return this.frmGroup.controls; }
  public edit(id: number) {
    this.id=id;
    this.isEdit = true;
    this.calendarService.getById(id).pipe(first())
      .subscribe(x => {
        this.frmGroup.patchValue(x);
        this.tuNgay=  x.tuNgay !== null ? new Date(this.datePipe.transform(x.tuNgay, 'yyyy-MM-dd')): new Date();
        this.denNgay= x.denNgay !== null ? new Date(this.datePipe.transform(x.denNgay, 'yyyy-MM-dd')): new Date();
        this.isSuDung = x.suDung === 1 ? true: false;
      });
    let files: CalendarFile[];
    this.fileLists =  [];
    this.calendarFileService.findAllByCalendarId(id).subscribe(
      x => {
        files = x;
        for(let i=0; i< files.length; i++)
        {
          this.fileLists.push({ id: files[i].id,
            title: files[i].name ,
            name: files[i].fileKey,
            size: files[i].size,
            fileType: files[i].width,
            folder: files[i].folder });
        }
        this.uploadFileComponent.uploadCommand["files"]= this.fileLists;


      });


  }
  public createItem ()
  {
    this.frmGroup.controls['beLongTo'].setValue(Sessioncommand.staffId);
    this.frmGroup.value.tuNgay = this.tuNgay;
    this.frmGroup.value.denNgay = this.denNgay;
    this.frmGroup.controls['suDung'].setValue(this.isSuDung == false ? 0: 1);
    this.calendarService.add(this.frmGroup.value).subscribe(
      {
        next: (data) => {
          this.uploadFileComponent.id = data.id;
          this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
          this.toastr.success(language.add_success_record, language.message);
          this.onConfirm();
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  public updateItem()
  {
    this.frmGroup.controls['beLongTo'].setValue(Sessioncommand.staffId);
    this.frmGroup.value.tuNgay = this.tuNgay;
    this.frmGroup.value.denNgay = this.denNgay;
    this.frmGroup.controls['suDung'].setValue(this.isSuDung == false ? 0: 1);
    this.calendarService.update(this.frmGroup.value).subscribe({
      next: (data) => {
        this.uploadFileComponent.id = data.id;
        this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
        this.toastr.success(language.update_success_record, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if (this.id != 0)
      this.updateItem();
    else
      this.createItem();
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

